export const EMPTY_STR = {
  TEXT: "--",
  DATE: "----/--/--",
  DATE_TIME: "----/--/-- --:--",
};
